const API = 'MediaUpload';

export const API_MEDIA_UPLOADS = {
  UPLOAD_FILE_TO_CLOUD: `${API}/UploadFileToCloud`,
  REMOVE_FILE_FROM_CLOUD: `${API}/RemoveFileFromCloud`,
  GET_HTML_FROM_CLOUD: `${API}/GetHtmlFromCloud`,
};

export interface MediaUpload {
  fileName: string;
  content: string;
  filePath?: string;
}
